document.addEventListener('DOMContentLoaded', function () {
  /* ===== Countdown da oferta ===== */
  document.querySelectorAll('[data-countdown-end]').forEach(function (el) {
    var endTime = new Date(el.getAttribute('data-countdown-end')).getTime();
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minEl = el.querySelector('[data-cd-minutes]');
    var secEl = el.querySelector('[data-cd-seconds]');

    function tick() {
      var now = new Date().getTime();
      var diff = endTime - now;
      if (diff <= 0) {
        el.style.display = 'none';
        return;
      }
      var h = Math.floor(diff / (1000 * 60 * 60));
      var m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((diff % (1000 * 60)) / 1000);
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minEl) minEl.textContent = String(m).padStart(2, '0');
      if (secEl) secEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ===== Barra de frete grátis ===== */
  document.querySelectorAll('[data-shipping-bar]').forEach(function (bar) {
    var goal = parseFloat(bar.getAttribute('data-goal')) || 0;
    var fill = bar.querySelector('[data-shipping-fill]');
    var message = bar.querySelector('[data-shipping-message]');
    var textBefore = bar.getAttribute('data-text-before') || 'Falta {{amount}} para frete grátis!';
    var textAfter = bar.getAttribute('data-text-after') || 'Você ganhou frete grátis! 🎉';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2).replace('.', ',');
      return 'R$' + value;
    }

    function updateBar() {
      fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var total = cart.total_price / 100;
          var pct = Math.min((total / goal) * 100, 100);
          if (fill) fill.style.width = pct + '%';
          if (total >= goal) {
            if (message) {
              message.textContent = textAfter;
              message.classList.add('is-complete');
            }
          } else {
            var remaining = goal - total;
            var remainingFormatted = formatMoney(Math.round(remaining * 100));
            if (message) {
              message.innerHTML = textBefore.replace('{{amount}}', '<strong>' + remainingFormatted + '</strong>');
              message.classList.remove('is-complete');
            }
          }
        })
        .catch(function () {});
    }

    updateBar();
    document.addEventListener('cart:refresh', updateBar);
    document.addEventListener('cart:update', updateBar);
  });

  /* ===== Seletor de compra em massa por variação ===== */
  document.querySelectorAll('[data-bulk-variant-selector]').forEach(function (widget) {
    var steppers = widget.querySelectorAll('[data-bulk-row]');
    var subtotalEl = widget.querySelector('[data-bulk-subtotal]');
    var countEl = widget.querySelector('[data-bulk-count]');
    var addButton = widget.querySelector('[data-bulk-add]');
    var errorEl = widget.querySelector('[data-bulk-error]');

    function recalc() {
      var total = 0;
      var count = 0;
      steppers.forEach(function (row) {
        var input = row.querySelector('input');
        var qty = parseInt(input.value, 10) || 0;
        var price = parseFloat(row.getAttribute('data-price'));
        total += qty * price;
        count += qty;
      });
      if (subtotalEl) subtotalEl.textContent = 'R$' + total.toFixed(2).replace('.', ',');
      if (countEl) countEl.textContent = count;
      if (addButton) addButton.disabled = count === 0;
    }

    widget.querySelectorAll('[data-bulk-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        var min = parseInt(input.getAttribute('min'), 10) || 0;
        var val = Math.max(min, (parseInt(input.value, 10) || 0) - 1);
        input.value = val;
        recalc();
      });
    });

    widget.querySelectorAll('[data-bulk-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        var row = btn.closest('[data-bulk-row]');
        var max = row.hasAttribute('data-max') ? parseInt(row.getAttribute('data-max'), 10) : Infinity;
        var val = (parseInt(input.value, 10) || 0) + 1;
        if (val > max) {
          val = max;
          showStockLimitWarning(row, max);
        }
        input.value = val;
        recalc();
      });
    });

    widget.querySelectorAll('[data-bulk-row] input').forEach(function (input) {
      input.addEventListener('input', function () {
        var row = input.closest('[data-bulk-row]');
        var max = row.hasAttribute('data-max') ? parseInt(row.getAttribute('data-max'), 10) : Infinity;
        var val = parseInt(input.value, 10) || 0;
        if (val < 0) val = 0;
        if (val > max) {
          val = max;
          showStockLimitWarning(row, max);
        }
        input.value = val;
        recalc();
      });
    });

    function showStockLimitWarning(row, max) {
      if (errorEl) {
        errorEl.textContent = 'Esta variação tem apenas ' + max + ' unidade(s) em estoque.';
        errorEl.style.display = 'block';
        clearTimeout(row._warningTimeout);
        row._warningTimeout = setTimeout(function () {
          errorEl.style.display = 'none';
        }, 3000);
      }
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        var items = [];
        steppers.forEach(function (row) {
          var input = row.querySelector('input');
          var qty = parseInt(input.value, 10) || 0;
          if (qty > 0) {
            items.push({ id: row.getAttribute('data-variant-id'), quantity: qty });
          }
        });

        if (items.length === 0) {
          if (errorEl) {
            errorEl.textContent = 'Selecione ao menos 1 unidade de alguma variação.';
            errorEl.style.display = 'block';
          }
          return;
        }

        addButton.disabled = true;
        addButton.textContent = 'Adicionando...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw err;
              });
            }
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              fetch('/cart?section_id=cart-drawer')
                .then(function (r) {
                  return r.text();
                })
                .then(function (html) {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var newContent = doc.querySelector('cart-drawer-items');
                  var oldContent = cartDrawer.querySelector('cart-drawer-items');
                  if (newContent && oldContent) oldContent.replaceWith(newContent);
                  cartDrawer.classList.remove('is-empty');
                  cartDrawer.open();
                });
            }
            steppers.forEach(function (row) {
              row.querySelector('input').value = 0;
            });
            recalc();
            addButton.textContent = 'Adicionar tudo ao carrinho';
            if (errorEl) errorEl.style.display = 'none';
          })
          .catch(function (err) {
            addButton.textContent = 'Adicionar tudo ao carrinho';
            addButton.disabled = false;
            if (errorEl) {
              errorEl.textContent = (err && err.message) || 'Não foi possível adicionar os produtos. Verifique o estoque.';
              errorEl.style.display = 'block';
            }
          });
      });
    }

    recalc();
  });
});

/* ===== Popup de personalização com bordado (Quick Order List) ===== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-embroidery-popup]').forEach(function (popup) {
    var feeVariantId = popup.getAttribute('data-fee-variant-id');
    var variantNameEl = popup.querySelector('[data-embroidery-variant-name]');
    var input = popup.querySelector('.embroidery-popup__input');
    var errorEl = popup.querySelector('[data-embroidery-error]');
    var confirmBtn = popup.querySelector('[data-embroidery-confirm]');
    var currentVariantId = null;

    function openPopup(variantId, variantTitle) {
      currentVariantId = variantId;
      if (variantNameEl) variantNameEl.textContent = variantTitle || '';
      input.value = '';
      errorEl.hidden = true;
      popup.hidden = false;
      input.focus();
    }

    function closePopup() {
      popup.hidden = true;
      currentVariantId = null;
    }

    popup.querySelectorAll('[data-embroidery-close]').forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) closePopup();
    });

    // Liga todos os botões "Personalizar com bordado" da página a este popup
    document.querySelectorAll('.embroidery-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPopup(trigger.getAttribute('data-variant-id'), trigger.getAttribute('data-variant-title'));
      });
    });

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var name = input.value.trim();
        if (!name) {
          errorEl.textContent = 'Digite o nome que deseja bordar.';
          errorEl.hidden = false;
          return;
        }
        if (!currentVariantId) {
          errorEl.textContent = 'Não foi possível identificar o produto. Feche e tente novamente.';
          errorEl.hidden = false;
          return;
        }

        var items = [
          {
            id: currentVariantId,
            quantity: 1,
            properties: { 'Nome do Bordado': name },
          },
        ];

        if (feeVariantId && feeVariantId !== '') {
          items.push({ id: feeVariantId, quantity: 1 });
        }

        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Adicionando...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw err;
              });
            }
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              fetch('/cart?section_id=cart-drawer')
                .then(function (r) {
                  return r.text();
                })
                .then(function (html) {
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(html, 'text/html');
                  var newContent = doc.querySelector('cart-drawer-items');
                  var oldContent = cartDrawer.querySelector('cart-drawer-items');
                  if (newContent && oldContent) oldContent.replaceWith(newContent);
                  cartDrawer.classList.remove('is-empty');
                  cartDrawer.open();
                });
            }
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'Confirmar e adicionar ao carrinho';
            closePopup();
          })
          .catch(function (err) {
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'Confirmar e adicionar ao carrinho';
            errorEl.textContent = (err && err.message) || 'Não foi possível adicionar ao carrinho. Verifique o estoque.';
            errorEl.hidden = false;
          });
      });
    }
  });
});

/* ===== Trava de estoque nos campos de quantidade (funciona em qualquer contexto:
   página de produto principal ou lista de compra em massa nativa) ===== */
document.addEventListener('DOMContentLoaded', function () {
  function enforceStockLimit(input) {
    if (!input.hasAttribute('data-max') || input._stockLimitBound) return;
    input._stockLimitBound = true;

    var max = parseInt(input.getAttribute('data-max'), 10);
    var messageText = input.getAttribute('data-stock-message') || 'Limite de quantidade em estoque atingida.';

    function findMessageBox() {
      // Busca pelo ID direto: o campo tem id "Quantity-XXX" e a mensagem
      // correspondente tem id "Stock-Limit-Message-XXX" (mesmo sufixo)
      if (input.id) {
        var suffix = input.id.replace(/^Quantity-/, '');
        var byId = document.getElementById('Stock-Limit-Message-' + suffix);
        if (byId) return byId;
      }

      // Reserva: tenta achar como próximo irmão do <quantity-input>
      var qi = input.closest('quantity-input');
      var candidate = qi ? qi.nextElementSibling : input.nextElementSibling;
      if (candidate && candidate.classList.contains('stock-limit-message')) {
        return candidate;
      }

      // Última reserva: cria a caixinha de mensagem na hora, caso não exista no HTML
      var created = document.createElement('div');
      created.className = 'stock-limit-message';
      created.setAttribute('role', 'alert');
      created.hidden = true;
      if (qi) {
        qi.insertAdjacentElement('afterend', created);
      } else {
        input.insertAdjacentElement('afterend', created);
      }
      return created;
    }

    var isClamping = false;

    function checkAndClamp() {
      if (isClamping) return;

      var value = parseInt(input.value, 10);
      if (isNaN(value)) return;

      var messageBox = findMessageBox();

      if (value > max) {
        isClamping = true;
        input.value = max;
        if (messageBox) {
          messageBox.textContent = messageText;
          messageBox.hidden = false;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
        isClamping = false;
      } else if (messageBox) {
        messageBox.hidden = true;
      }
    }

    // Verificação específica pro botão "+": o navegador já impede nativamente
    // de passar do "max" (via stepUp), então precisamos checar se o valor
    // CHEGOU no limite, não só se passou dele, senão a mensagem nunca apareceria
    function checkIfReachedCeiling() {
      var value = parseInt(input.value, 10);
      if (isNaN(value)) return;

      var messageBox = findMessageBox();
      if (!messageBox) return;

      if (value >= max) {
        messageBox.textContent = messageText;
        messageBox.hidden = false;
      } else {
        messageBox.hidden = true;
      }
    }

    input.addEventListener('input', checkAndClamp);
    input.addEventListener('change', checkAndClamp);

    var quantityWrapper = input.closest('quantity-input');
    if (quantityWrapper) {
      var plusButton = quantityWrapper.querySelector('button[name="plus"]');
      if (plusButton) {
        plusButton.addEventListener('click', function () {
          setTimeout(checkIfReachedCeiling, 0);
        });
      }
    }
  }

  function bindAllStockLimits() {
    document.querySelectorAll('input[data-max]').forEach(enforceStockLimit);
  }

  bindAllStockLimits();

  // Reaplica quando o carrinho ou a lista de variantes atualiza (conteúdo re-renderizado)
  document.addEventListener('cart:update', bindAllStockLimits);
  document.addEventListener('cart:refresh', bindAllStockLimits);

  // A Quick Order List re-renderiza linhas via AJAX às vezes; observa mudanças no DOM
  var quickOrderList = document.querySelector('quick-order-list');
  var stockObserver = null;
  if (quickOrderList && window.MutationObserver) {
    stockObserver = new MutationObserver(function () {
      if (stockObserver) stockObserver.disconnect();
      bindAllStockLimits();
      if (stockObserver && quickOrderList) {
        stockObserver.observe(quickOrderList, { childList: true, subtree: true });
      }
    });
    stockObserver.observe(quickOrderList, { childList: true, subtree: true });
  }
});

/* ===== Aviso de desconto no atacado por coleção (soma ao vivo das quantidades) ===== */
document.addEventListener('DOMContentLoaded', function () {
  function setupWholesaleBanner(banner) {
    if (banner._wholesaleBound) return;
    banner._wholesaleBound = true;

    var minQty = parseInt(banner.getAttribute('data-min-qty'), 10) || 0;
    var pct = banner.getAttribute('data-discount-pct') || '0';
    var textBefore = banner.getAttribute('data-text-before') || '';
    var textAfter = banner.getAttribute('data-text-after') || '';

    // Acha o container da Quick Order List logo depois do aviso
    var container = banner.parentElement;
    if (!container) return;

    function getAllQuantityInputs() {
      return container.querySelectorAll('quick-order-list input[type="number"], quick-order-list input.quantity__input');
    }

    function formatMoneyBR(value) {
      return 'R$\u00a0' + value.toFixed(2).replace('.', ',');
    }

    function updateRowPrices(unlocked) {
      var priceEls = container.querySelectorAll('[data-wholesale-price-variant]');
      priceEls.forEach(function (el) {
        if (unlocked) {
          var original = parseFloat(el.getAttribute('data-original-price'));
          if (isNaN(original)) return;
          var discounted = original * (1 - parseFloat(pct) / 100);
          el.innerHTML =
            '<s class="wholesale-price-original">' +
            formatMoneyBR(original) +
            '</s> <span class="wholesale-price-discounted">' +
            formatMoneyBR(discounted) +
            '/cada</span>';
        } else {
          var originalHtml = el.getAttribute('data-original-html');
          if (originalHtml !== null) {
            el.innerHTML = originalHtml;
          }
        }
      });
    }

    // NOVO: recalcula o "Total das variantes" de cada linha e o "Subtotal do
    // produto" lá embaixo, porque esses dois são calculados pelo carrinho
    // real da Shopify (que não sabe desse desconto visual) e ficavam com o
    // valor cheio, sem desconto, mesmo com o preço "por unidade" já correto
    function updateRowTotalsAndSubtotal(unlocked) {
      var priceEls = container.querySelectorAll('[data-wholesale-price-variant]');
      var grandTotal = 0;
      var seenVariants = {};

      priceEls.forEach(function (el) {
        var variantId = el.getAttribute('data-wholesale-price-variant');
        var original = parseFloat(el.getAttribute('data-original-price'));
        if (isNaN(original)) return;
        var unitPrice = unlocked ? original * (1 - parseFloat(pct) / 100) : original;

        var qtyInput = container.querySelector('input[data-quantity-variant-id="' + variantId + '"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
        var lineTotal = unitPrice * qty;

        // Cada linha tem 2 células de total (uma pro mobile, outra pro
        // desktop) — atualiza as duas
        var row = el.closest('tr');
        if (row) {
          row.querySelectorAll('.variant-item__totals .price').forEach(function (totalEl) {
            totalEl.textContent = formatMoneyBR(lineTotal);
          });
        }

        // Cada variante aparece 2x no HTML (célula mobile + desktop), soma só uma vez
        if (!seenVariants[variantId]) {
          seenVariants[variantId] = true;
          grandTotal += lineTotal;
        }
      });

      var subtotalEl = container.querySelector('.totals__subtotal-value');
      if (subtotalEl) {
        subtotalEl.textContent = formatMoneyBR(grandTotal);
      }
    }

    function updateBanner() {
      var inputs = getAllQuantityInputs();
      var total = 0;
      inputs.forEach(function (input) {
        var val = parseInt(input.value, 10);
        if (!isNaN(val)) total += val;
      });

      if (total >= minQty) {
        banner.textContent = textAfter.replace('{pct}', pct);
        banner.classList.add('is-unlocked');
        updateRowPrices(true);
        updateRowTotalsAndSubtotal(true);
      } else {
        var remaining = minQty - total;
        banner.textContent = textBefore.replace('{remaining}', remaining).replace('{pct}', pct);
        banner.classList.remove('is-unlocked');
        updateRowPrices(false);
        updateRowTotalsAndSubtotal(false);
      }
    }

    function bindInputs() {
      getAllQuantityInputs().forEach(function (input) {
        if (input._wholesaleListenerBound) return;
        input._wholesaleListenerBound = true;
        input.addEventListener('input', updateBanner);
        input.addEventListener('change', updateBanner);
      });
    }

    bindInputs();
    updateBanner();

    // A Quick Order List pode re-renderizar linhas via AJAX; observa e reconecta.
    // Importante: desconecta o observer antes de nós mesmos mudarmos o HTML
    // (senão nossa própria mudança de preço dispara o observer de novo, em loop infinito)
    var quickOrderList = container.querySelector('quick-order-list');
    var wholesaleObserver = null;
    if (quickOrderList && window.MutationObserver) {
      wholesaleObserver = new MutationObserver(function () {
        if (wholesaleObserver) wholesaleObserver.disconnect();
        bindInputs();
        updateBanner();
        if (wholesaleObserver && quickOrderList) {
          wholesaleObserver.observe(quickOrderList, { childList: true, subtree: true });
        }
      });
      wholesaleObserver.observe(quickOrderList, { childList: true, subtree: true });
    }
  }

  document.querySelectorAll('[data-wholesale-banner]').forEach(setupWholesaleBanner);
});